module.exports = __webpack_public_path__ + "img/pic04.6c42ed0c.png";